'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('service-requests-list', {
      url: '/service-requests/list',
      template: '<service-requests-list></service-requests-list>'
    });
}



// WEBPACK FOOTER //
// ./client/app/service-requests/list/service-requests-list.routes.js